var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { BoostUrlController } from './BoostUrlController';
import { Callback } from '../enums/Callback';
import { CallbackStatus as CallbackStatus } from '../enums/CallbackStatus';
import { BoostInvoiceController } from './BoostInvoiceController';
import { BoostNavigationController } from './BoostNavigationController';
import { BoostPortalNavigationSteps } from '../enums/BoostPortalNavigationSteps';
import { TrackingFactorySingleton } from '../tracking/TrackingFactorySingleton';
export class BoostVippsPaymentController {
    constructor(host) {
        this.currentStep = BoostPortalNavigationSteps.DEPARTMENT;
        this._stepRequirements = {
            [BoostPortalNavigationSteps.DEPARTMENT]: () => true,
            [BoostPortalNavigationSteps.INFORMATION]: () => Boolean(this.selectedDepartmentId),
            [BoostPortalNavigationSteps.DIRECTDEBIT]: () => false,
            [BoostPortalNavigationSteps.PAYMENT]: () => Boolean(this.getInvoiceId()) && Boolean(this.registeredMember),
            [BoostPortalNavigationSteps.SUCCESS]: () => this.isCallbackNets || this.isCallbackVipps,
            [BoostPortalNavigationSteps.SPONSOR]: () => true,
        };
        this.host = host;
        host.addController(this);
        this.urlController = new BoostUrlController(host);
        this.invoiceController = new BoostInvoiceController(host);
        this.navigationController = new BoostNavigationController(host, this);
        this.urlController.onHistoryStateChange = () => {
            this.setCurrentStep(this.currentStep);
            this.navigationController.onCallbackChange();
        };
        this.urlController.onInvoiceIdChange = (id) => this.invoiceController.setInvoiceId(id);
        this.urlController.onCallbackChange = () => this.navigationController.onCallbackChange();
        this.invoiceController.onInvoiceChange = () => this.navigationController.onCallbackChange();
    }
    hostConnected() {
        this.urlController.getParameterDataFromUrl();
        this.host.requestUpdate();
    }
    setCurrentStep(newStep) {
        const oldStep = this.currentStep;
        if (newStep < oldStep &&
            (newStep === BoostPortalNavigationSteps.INFORMATION ||
                newStep === BoostPortalNavigationSteps.DEPARTMENT) &&
            oldStep !== BoostPortalNavigationSteps.SUCCESS) {
            this.currentStep = newStep;
            this.host.requestUpdate();
            return;
        }
        const fulfilledStepRequirement = this._stepRequirements[newStep]();
        if (newStep > oldStep && !fulfilledStepRequirement) {
            return;
        }
        else if (!fulfilledStepRequirement) {
            return;
        }
        else if (oldStep === BoostPortalNavigationSteps.SUCCESS) {
            return;
        }
        this.currentStep = newStep;
        this.host.requestUpdate();
    }
    setTrackerCompletedEvent(completedEvent) {
        TrackingFactorySingleton.getTracker().completedEvent(completedEvent);
        this.host.requestUpdate();
    }
    setCallback(callback) {
        this.urlController.callback = callback;
        this.host.requestUpdate();
    }
    getInvoice() {
        return this.invoiceController.getInvoice;
    }
    getInvoiceId() {
        return this.invoiceController.invoiceId;
    }
    setInvoiceId(invoiceId) {
        this.invoiceController.setInvoiceId(invoiceId);
    }
    setSelectedDepartmentId(departmentId) {
        this.selectedDepartmentId = departmentId;
    }
    setRegisteredMember(registeredMember) {
        this.registeredMember = registeredMember;
    }
    get isCallbackNets() {
        return this.urlController.callback === Callback.NETS;
    }
    get isCallbackStatusSuccess() {
        return this.urlController.netsStatus === CallbackStatus.SUCCESS;
    }
    get isCallbackVipps() {
        return this.urlController.callback === Callback.VIPPS;
    }
    get isNetsStatusFailed() {
        return this.urlController.netsStatus === CallbackStatus.FAILED;
    }
    get isVippsSetup() {
        return this.urlController.isVippsSetup;
    }
    get isNoDirectDebit() {
        return this.urlController.noDirectDebit;
    }
    get shouldGoToPaymentStepDirectDebit() {
        var _a;
        return this.urlController.noDirectDebit && !((_a = this.invoiceController.invoice) === null || _a === void 0 ? void 0 : _a.invoice.rest);
    }
    isInvoicePaid() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.isVippsSetup) {
                return true;
            }
            return yield this.invoiceController.isInvoicePaid();
        });
    }
}
